import { render, staticRenderFns } from "./iconLock.vue?vue&type=template&id=0228e65c&scoped=true"
import script from "./iconLock.vue?vue&type=script&lang=js"
export * from "./iconLock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0228e65c",
  null
  
)

export default component.exports